import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    a1_h3: {
        id: "landing.features.a1.h3",
    },
    a2_h3: {
        id: "landing.features.a2.h3",
    },
    a3_h3: {
        id: "landing.features.a3.h3",
    },
    a1_d: {
        id: "landing.features.a1.d",
    },
    a2_d: {
        id: "landing.features.a2.d",
    },
    a3_d: {
        id: "landing.features.a3.d",
    },
    join: {
        id: "landing.features.join",
    },
    start: {
        id: "landing.start",
    },
});

export default messages;
